import React from 'react';
import styled from 'styled-components';
import Axios from '../axios';
import request from '../../../request';
import { Flex, Text, Loading } from '../components';
import PostMessage from '../post-message-service/post-message-service';

class EverifyForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      iframeUrl: '',
      section1CompletedAt: null,
      section2Completed: null,
      ecasesKey: '',
      recordDeletedAt: '',
    };
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    PostMessage.removeReceiver();
  }

  componentDidMount() {
    const { onTaskCompleted } = this.props;
    PostMessage.initialize(onTaskCompleted);
    this.setupFormI9Info();
  }

  fetchEcasesStatus() {
    const { ecasesKey } = this.state;
    if (!ecasesKey) {
      return;
    }
    const statusAPIUrl = `${APIHOST}/v1/onboarding/formi9_compliance/employee/ecases/${ecasesKey}/status`;
    const headers = {
      ...(authCode && { Authorization: authCode }),
    };
    return request('GET', statusAPIUrl, {}, headers);
  }

  fetchFormI9() {
    const { digestKey } = this.props;
    const apiURL = `${APIHOST}/v1/onboarding/formi9_compliance/employee/ecases/find_by_process`;
    const data = {
      process_digest_key: digestKey,
    };
    const headers = {
      ...(authCode && { Authorization: authCode }),
    };
    return request('GET', apiURL, data, headers);
  }

  setupFormI9Info() {
    const { action: { action_type: actionType } } = this.props;
    this.setState({ isLoading: true });
    this.fetchFormI9().then((responseData) => {
      const {
        section1_completed_at: section1CompletedAt,
        digest_key: ecasesKey,
        record_deleted_at: recordDeletedAt,
      } = responseData.data;
      this.setState({
        section1CompletedAt,
        ecasesKey,
        recordDeletedAt,
        isLoading: !recordDeletedAt,
      });
      if (actionType === 'formi9_section2') {
        this.setState({
          isLoading: section1CompletedAt,
        });
      }
      if (!recordDeletedAt) {
        this.fetchEcasesStatus().then((response) => {
          this.setState({
            iframeUrl: response.data.autoLoginUrl,
          });
        });
      }
    });
  }

  fetchProcessInfo() {
    const {
      digestKey,
      authCode,
      action: { digest_key: actionId },
    } = this.props;
    const path = `${APIHOST}/v1/employee_onboarding_processes/${digestKey}`;
    return request(
      'GET',
      path,
      {
        ...(actionId && { onboarding_action_id: actionId }),
      },
      { ...(authCode && { Authorization: authCode }) },
    );
  }

  runIntervalAction() {
    this.interval = setInterval(() => {
      if (this.isFocus) {
        this.fetchProcessInfo().then((response) => {
          const formI9Module = response.data.employee_onboarding_process.employee_onboarding_modules.find(
            (m) => m.module_type === 'formi9_compliance_everify',
          );
          const section2Action = formI9Module.actions.find((a) => a.action_type === 'formi9_section2');
          this.setState({
            section2Completed: section2Action.status,
          });
          if (section2Action.status === 'completed') {
            window.location.reload();
          }
        });
      }
    }, 1500);
  }

  checkIfSection2Complete() {
    const { section2Completed } = this.state;
    if (section2Completed === 'completed' && this.interval) {
      clearInterval(this.interval);
      return;
    }
    this.isFocus = true;
    if (!this.interval) {
      this.runIntervalAction();
    }
    window.addEventListener('focus', () => {
      this.isFocus = true;
    });
    window.addEventListener('blur', () => {
      if (document.activeElement.id === 'section2_iframe') return;
      this.isFocus = false;
    });
  }

  renderSection2Content() {
    const {
      iframeUrl, section1CompletedAt, isLoading, recordDeletedAt,
    } = this.state;
    if (section1CompletedAt) {
      this.checkIfSection2Complete();
    }
    if (recordDeletedAt) {
      return (
        <Flex>
          {this.renderInfoContent('Something went wrong while filling section 2. Please contact your manager for assistance')}
        </Flex>
      );
    }
    return (
      <Flex>
        {
          isLoading && (
            <Flex>
              <Loading className="spinner spinner-blue" />
            </Flex>
          )
        }
        {
          section1CompletedAt && iframeUrl && (
            <iframe
              id="section2_iframe"
              onLoad={() => {
                this.setState({ isLoading: false });
              }}
              style={{
                width: '100%',
                height: '700px',
              }}
              src={iframeUrl}
            />
          )
        }
        {
          !section1CompletedAt && !isLoading && this.renderInfoContent('Waiting for the employee to fill out section1.')
        }
      </Flex>
    );
  }

  renderSection1Content() {
    const { iframeUrl, isLoading } = this.state;
    return (
      <Flex>
        {
          isLoading && (
            <Flex>
              <Loading className="spinner spinner-blue" />
            </Flex>
          )
        }
        {
          iframeUrl && (
            <iframe
              id="section1_iframe"
              onLoad={() => {
                this.setState({ isLoading: false });
              }}
              style={{
                width: '100%',
                height: '700px',
              }}
              src={this.state.iframeUrl}
            />
          )
        }
        {
          !isLoading && !iframeUrl && (
            this.renderInfoContent('Something went wrong while filling section 1. Please contact your manager for assistance.')
          )
        }
      </Flex>
    );
  }

  renderInfoContent(info) {
    return (
      <Flex column alignItems="center" justifyContent="center">
        <Flex column mt={[50, 0]} ml={[0, 123]}>
          <Text mt={1}>{info}</Text>
        </Flex>
      </Flex>
    );
  }

  renderContent() {
    const { action, companyStaff, authCode } = this.props;
    const { action_type: actionType, name } = action;
    switch (actionType) {
      case 'formi9_section1':
        if (action.status === 'not_started' || action.status === 'in_progress' || action.status === 'redo') {
          if ((companyStaff && companyStaff.manage_onboarding) || authCode) {
            return this.renderInfoContent(`${name} is still in progress.`);
          }
          return this.renderSection1Content();
        }
        return this.renderInfoContent(`${name} has been completed.`);

      case 'formi9_section2':
        if (action.status === 'not_started' || action.status === 'in_progress' || action.status === 'redo') {
          return this.renderSection2Content();
        } if (companyStaff && companyStaff.manage_onboarding) {
          return this.renderInfoContent(`${name} has been completed.`);
        }
        return this.renderInfoContent(`${name} has been completed.`);

      default:
        return this.renderInfoContent(`Not supported action type ${actionType}`);
    }
  }

  render() {
    return (
      <Flex column style={{ width: '100%' }}>
        {this.renderContent()}
      </Flex>
    );
  }
}

export const markAsComplete = (actionType, onTaskCompleted) => {
  const { processData, APIHOST, authCode } = window;
  const currentDisplayActionId = processData.current_display_action_id;
  const formI9Module = processData.employee_onboarding_modules.find((m) => m.module_type === 'formi9_compliance_everify');
  const currentAction = formI9Module.actions.find((action) => action.action_type === actionType);
  const currentActionId = currentAction.id;
  if (currentDisplayActionId !== currentActionId) {
    return;
  }
  const digestKey = currentAction.digest_key;
  const apiURL = `${APIHOST}/v1/onboarding/employee/employee_onboarding_actions/${digestKey}/completed`;
  const config = {
    method: 'PUT',
    url: apiURL,
    headers: {
      ...(authCode && { Authorization: authCode }),
    },
  };
  Axios(config)
    .then(() => {
      onTaskCompleted();
    });
};

export default EverifyForm;
